<div class="modal-header border-bottom p-3">
  <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
    {{ "CreditPayment" | translate }}
  </h6>
  <button
    type="button"
    class="btn-close-modal btn-icon btn-close"
    (click)="callParent('closeCredit')"
    aria-label="Close"
  ></button>
</div>

<div class="modal-body mx-0 flex-grow-0">
  <div class="third-box row">
    <div class="check-ui-show col-12 position-relative">
      <img
        class="check-image"
        src="../../../../assets/img/check.gif"
        alt="check"
      />
      <p class="check-date">{{ checkValue.factorDate | dataType : "" }}</p>
      <p class="check-date-character">
        {{ checkValue.factorDate | dataType : "" }}
      </p>
      <input
        class="check-price"
        type="text"
        [(ngModel)]="checkValue.cost"
        disabled
      />
      <input
        class="check-character-price"
        type="text"
        [(ngModel)]="checkValue.cost"
        disabled
      />
      <input
        class="check-reciver"
        type="text"
        [(ngModel)]="checkValue.receiver"
        disabled
      />
      <input
        class="check-reciver-national-code"
        type="text"
        [(ngModel)]="checkValue.nationalCode"
        disabled
      />
      <input
        class="check-number"
        type="text"
        [(ngModel)]="checkValue.checkNumber"
        disabled
      />
    </div>
    <div class="col-12">
      <div id="accordionIcon" class="accordion mt-3 accordion-without-arrow">
        <div class="accordion-item card">
          <h2
            class="accordion-header text-body d-flex justify-content-between"
            id="accordionIconOne"
          >
            <button
              type="button"
              class="accordion-button collapsed collapse-checkBook-header"
              data-bs-toggle="collapse"
              data-bs-target="#accordionIcon-1"
              aria-controls="accordionIcon-1"
            >
              {{ "CheckBook" | translate }}
            </button>
          </h2>

          <div
            id="accordionIcon-1"
            class="accordion-collapse collapse collapse-checkBook"
            data-bs-parent="#accordionIconOne"
          >
            <div class="accordion-body lh-2 row">
              <div class="col-12 col-lg-3 col-md-6 p-0" *ngFor="let checkBook of checkBooks">
                <div class="check-book-box p-0 my-2">
                  <button
                    type="button"
                    class="box-btn"
                    (click)="getCheck(checkBook)"
                  >
                    <div class="px-1">
                      <i class="bx bxs-book-bookmark"></i>
                    </div>
                    <span class="px-2">
                      {{ checkBook.name }}
                    </span>
                    <app-loading-panel
                      *ngIf="checkBook.loading"
                    ></app-loading-panel>
                  </button>
                  <button
                    type="button"
                    *ngFor="let check of checkBook.checks; let i = index"
                    class="btn-checkbook-check mx-2 my-1 animate__animated animate__fadeInRight"
                    [ngClass]="{
                      'btn-check-pass': check.isPassed,
                      'btn-check-use': check.paymentId != null,
                      'btn-current-use': check.isSelect
                    }"
                    [style.animation-delay]="i * 0.4 + 's'"
                    (click)="selectCheck(check)"
                  >
                    <i class="fas fa-money-check me-2"></i>
                    {{ check.checkNumber }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item card">
          <h2
            class="accordion-header text-body d-flex justify-content-between"
            id="accordionIconThree"
          >
            <button
              type="button"
              class="accordion-button collapsed collapse-check-detail-header"
              data-bs-toggle="collapse"
              data-bs-target="#accordionIcon-3"
              aria-controls="accordionIcon-3"
            >
              {{ "CheckDetail" | translate }}
            </button>
          </h2>

          <div
            id="accordionIcon-3"
            class="accordion-collapse collapse collapse-check-detail"
            data-bs-parent="#accordionIconThree"
          >
            <div class="accordion-body lh-2 row">
              <div class="col-12 col-lg-3 col-md-6 position-relative">
                <div class="validation-alert" *ngIf="checkValue.cost != null">
                  <p class="m-0 p-0">{{ checkValue.costMassage }}</p>

                  <label class="form-label" for="checkPriceNumber">
                    {{ "checkPriceNumber" | translate }}
                  </label>
                </div>
                <input
                  id="checkPriceNumber"
                  type="text"
                  class="form-control"
                  [(ngModel)]="checkValue.cost"
                  (keyup)="checkMaxFactor()"
                  mask="separator.0"
                  thousandSeparator=","
                />

                <span class="set-position-rial-prefix-inside-merge-div">
                  {{ "Rial" | translate }}
                </span>
              </div>
              <div class="col-12 col-lg-3 col-md-6">
                <div
                  class="validation-alert"
                  *ngIf="checkValue.checkDate != null"
                >
                  <p class="m-0 p-0">{{ checkValue.checkDateMessage }}</p>
                  <label class="form-label" for="checkDate">
                    {{ "checkDate" | translate }}
                  </label>
                </div>
                <input
                  type="text"
                  class="form-control"
                  [ngClass]="{
                    'is-invalid':
                      checkValue.checkDateMessage != '' &&
                      checkValue.checkDateMessage != null
                  }"
                  id="factorDate"
                  [ngModel]="checkValue.checkDate | dataType : '' : false"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="YYYY/MM/DD"
                  [ngbPopover]="popoverDatapickerfactorDate"
                  #datePicker="ngbPopover"
                  [autoClose]="'outside'"
                  autocomplete="disabled"
                />

                <ng-template #popoverDatapickerfactorDate>
                  <app-data-picker
                    [(childProp)]="checkValue.checkDate"
                    (changeVariableMonth)="changeMonth($event)"
                  ></app-data-picker>
                </ng-template>
              </div>
              <div class="col-12 col-lg-3 col-md-6">
                <div
                  class="validation-alert"
                  *ngIf="checkValue.receiver != null"
                >
                  <p class="m-0 p-0">{{ checkValue.receiver }}</p>
                  <label class="form-label" for="checkPayTo">
                    {{ "checkPayTo" | translate }}
                  </label>
                </div>
                <input
                  id="checkPayTo"
                  type="text"
                  class="form-control"
                  [(ngModel)]="checkValue.receiver"
                />
              </div>
              <div class="col-12 col-lg-3 col-md-6">
                <div
                  class="validation-alert"
                  *ngIf="checkValue.nationalCode != null"
                >
                  <p class="m-0 p-0">{{ checkValue.nationalCode }}</p>

                  <label class="form-label" for="checkPayNationalCode">
                    {{ "checkPayNationalCode" | translate }}
                  </label>
                </div>
                <input
                  id="checkPayNationalCode"
                  type="number"
                  class="form-control"
                  [(ngModel)]="checkValue.nationalCode"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer border-top p-3 justify-content-center">
  <button
    type="submit"
    class="btn btn-primary me-sm-3 me-1 data-submit"
    (click)="savePaymentInfo()"
  >
    {{ "Submit" | translate }}
  </button>
</div>

<app-pcsuccess-modal
  [showModal]="modalSuccessConfirm"
  (parentAction)="parentAction($event)"
>
</app-pcsuccess-modal>
